export const REGULAR_DENSITY = 'regular';
export const COMPACT_DENSITY = 'compact';

export type Density = typeof REGULAR_DENSITY | typeof COMPACT_DENSITY;
